import { gql } from '@apollo/client'

export const REASSIGN_CASE_EMAIL_MUTATION = gql`
  mutation ReassignCaseEmail($emailId: ID!, $caseId: ID, $processingId: ID) {
    reassignCaseEmail(emailId: $emailId, caseId: $caseId, processingId: $processingId) {
      caseEmail {
        id
        m2Case {
          id
          identifier
        }
      }
      errors
    }
  }
`
